<template>
  <span>
    <v-autocomplete
      :key="clear"
      v-model="selectedSuburb"
      :items="items"
      :loading="suburbLoading"
      :search-input.sync="suburbSearch"
      :label="label"
      :placeholder="placeholder || label || 'Select Suburb'"
      :outlined="outlined"
    ></v-autocomplete>
  </span>
</template>

<script>
import { axios } from '../utils'

export default {
  props: {
    value: {},
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    outlined: {
      default: false
    },
    clear: { default: true }
  },
  data() {
    return {
      items: [],
      selectedSuburb: '',
      suburbLoading: false,
      suburbSearch: null
    }
  },
  watch: {
    suburbSearch(value) {
      this.suburbLoading = true
      axios
        .get(`api/admin/admin-suburbs?q=${value}`)
        .then(res => {
          console.log(res.data)
          this.items = (Array.isArray(res.data) ? res.data : []).filter(
            item => item != null && item !== ''
          )
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.suburbLoading = false
        })
    },
    selectedSuburb: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.selectedSuburb = value == null ? '' : value
      this.items = this.items.filter(item => item != null && item !== '')
      if (value != null && value !== '' && !this.items.includes(value)) {
        this.items.push(value)
      }
    },
    clear: function() {
      this.items = []
      this.selectedSuburb = ''
      this.suburbSearch = null
      this.$emit('clear') // Emit an event when clearing
    }
  }
}
</script>

<style></style>
